/** The visible part of a view, excluding the notes pane covering its right edge. */
export function visibleViewRect(viewport) {
  if (!viewport?.isConnected) return null;
  const rect = viewport.getBoundingClientRect();
  const left = Math.max(0, rect.left + viewport.clientLeft);
  const top = Math.max(0, rect.top + viewport.clientTop);
  let right = Math.min(window.innerWidth, rect.left + viewport.clientLeft + viewport.clientWidth);
  const bottom = Math.min(window.innerHeight, rect.top + viewport.clientTop + viewport.clientHeight);
  const pane = document.querySelector('.notes-overlay.active');
  if (pane && pane.getClientRects().length) {
    const cover = pane.getBoundingClientRect();
    if (cover.right > left && cover.left < right && cover.bottom > top && cover.top < bottom) {
      right = Math.min(right, cover.left);
    }
  }
  if (right <= left || bottom <= top) return null;
  return {left, top, right, bottom, x: (left + right) / 2, y: (top + bottom) / 2};
}

/** Pixel translation from a rendered task's center to the usable view center. */
export function centeringOffset(viewport, task) {
  const visible = visibleViewRect(viewport);
  if (!visible || !task?.getClientRects().length) return null;
  const rect = task.getBoundingClientRect();
  return {x: visible.x - (rect.left + rect.width / 2), y: visible.y - (rect.top + rect.height / 2)};
}
